import { UseMutateFunction } from 'react-query';
import { Project } from 'api/project';
import { FieldValueType } from 'api/tasks';
import { getComparator } from 'components/organisms/tasks/comparators';
import { ProjectGridPayload } from 'queries/project';
import { ProjectField } from 'stores/fields';

type GridCellUpdateReturnType = (
  {
    projectId,
  }: {
    projectId: number;
  },
  field: ProjectField,
  from: FieldValueType,
  to: FieldValueType,
) => void;

const getProjectPayload = (field: ProjectField, newValue: FieldValueType) => {
  const { fieldId, customField, fieldName } = field;

  if (customField) {
    return { fields: [{ fieldId, fieldValue: newValue }] };
  }

  if (!fieldName) {
    return null;
  }

  return {
    [fieldName]: newValue,
  };
};

export const getGridUpdater = (
  mutate: UseMutateFunction<Project, unknown, ProjectGridPayload>,
): GridCellUpdateReturnType => {
  const updater = (
    { projectId }: { projectId: number },
    field: ProjectField,
    from: FieldValueType = null,
    to: FieldValueType = null,
  ): void => {
    const isSame =
      from === to || (getComparator(field)?.(from, to) ?? -1) === 0;

    if (isSame) {
      return;
    }
    const payload = getProjectPayload(field, to);

    if (!payload) {
      return;
    }
    mutate({ payload, projectId });
  };

  return updater;
};
